var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25375 1.5H9.75375L5.99625 6.225L2.25375 1.5ZM0.19125 1.2075C1.70625 3.15 4.50375 6.75 4.50375 6.75V11.25C4.50375 11.6625 4.84125 12 5.25375 12H6.75375C7.16625 12 7.50375 11.6625 7.50375 11.25V6.75C7.50375 6.75 10.2937 3.15 11.8088 1.2075C12.1912 0.7125 11.8388 0 11.2163 0H0.78375C0.16125 0 -0.19125 0.7125 0.19125 1.2075Z",
    fill: "#0F5DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.ef6427ca.svg";
export { ForwardRef as ReactComponent };